import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginResponseData } from '../models/responses/login-response-data';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { NewContractRequest } from '../models/requests/new-contract-request';
import { adhocDto } from '../models/adhocDto';
import { ContractVm } from '../models/requests/ConractVm';
import { approveContractVm } from '../models/approveContractVm';
import { UpdateContract } from '../models/requests/update-contract';
import { EmpNumberChangeRequestDto } from '../models/EmpNumberChangeRequestDto';
import { ContractRenewalRequestDto } from '../models/ContractRenewalRequestDto';
import { DateRangeRequest } from '../models/requests/DateRangeRequest';
import { ContractPendingApprovalDto } from '../models/ContractPendingApprovalDto';
import { approveContractAxiom } from '../models/approveContractAxiom';
import { adhocVm } from '../models/requests/adhocVm';
import { approveAddhoc } from '../models/approveAdhoc';
import { RequestApprovalDto } from '../models/requestapproval-dto';
@Injectable({
  providedIn: 'root'
})
export class AdHocService {
  
    private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': `Bearer ${localStorage.getItem('AT')}`,
      'Content-Type': 'application/json'
    });
  }

  private request<T>(method: 'GET' | 'POST', url: string, body?: any): Observable<ApiResponseObject<T>> {
    return this.httpClient.request<ApiResponseObject<T>>(method, `${environment.apiUrl}/${url}`, {
      body,
      headers: this.getHeaders()
    });
  }

 

  constructor(private httpClient: HttpClient) { }
  getAdhocRequest(): Observable<ApiResponseObject<adhocDto[]>> {
     ; 
    var result = this.httpClient.get<ApiResponseObject<adhocDto[]>>(`${environment.apiUrl}/AdhocRequest`);
    return result;
  }
  
   saveAdhoc(request: adhocVm): Observable<ApiResponseObject<any>> {
    return this.request('POST', 'AdhocRequest', request);
  }

  getMyPendingAdHoc(): Observable<ApiResponseObject<adhocDto[]>> {
    return this.httpClient.get<ApiResponseObject<adhocDto[]>>(`${environment.apiUrl}/AdhocRequest` );
  }

   getCurrentUserPendingRequest(): Observable<ApiResponseObject<adhocDto[]>> {
    return this.request('GET', 'AdhocRequest/MyPendingContract');
  }
   getAdhocForCurrentUser(): Observable<ApiResponseObject<adhocDto[]>> {
    return this.request('GET', 'AdhocRequest/GetContractsForCurrentUser');
  }

   approveContract(approveAddhocRequest: approveAddhoc): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/AdhocRequest/Approve`, approveAddhocRequest);
  }

  rejectContract(approveAddhocRequest: approveAddhoc): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/AdhocRequest/Reject`, approveAddhocRequest);
  }

  getRequestApprovals(id:number): Observable<ApiResponseObject<RequestApprovalDto[]>> {
      return this.httpClient.get<ApiResponseObject<RequestApprovalDto[]>>(`${environment.apiUrl}/AdhocRequest/GetPendingApproval/${id}`);
    }
   getadhocRequestApprovals(contractId:number): Observable<ApiResponseObject<RequestApprovalDto[]>> {
    return this.httpClient.get<ApiResponseObject<RequestApprovalDto[]>>(`${environment.apiUrl}/RequestApprovals/GetAdhocByRequestId${contractId}`);
  }
  updatePONumber(updateRequest: adhocDto): Observable<ApiResponseObject<adhocDto>> {
   
    return this.httpClient.put<ApiResponseObject<adhocDto>>(`${environment.apiUrl}/AdhocRequest/UpdatePO`, updateRequest);
  }

   ChangeNoOfEmployees(updateRequest: any): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.put<ApiResponseObject<boolean>>(`${environment.apiUrl}/AdhocRequest/ChangeNoOfEmployees`, updateRequest);
  }

  terminateRequest(data: any): Observable<ApiResponseObject<adhocDto>> {

    return this.httpClient.post<ApiResponseObject<adhocDto>>(`${environment.apiUrl}/AdhocRequest/CloseRequest`, data);
  }
  CancelRequest(data: any): Observable<ApiResponseObject<adhocDto>> {

    return this.httpClient.post<ApiResponseObject<adhocDto>>(`${environment.apiUrl}/AdhocRequest/CancelRequest`, data);
  }

  GetPendingEmpChangeRequest(): Observable<ApiResponseObject<EmpNumberChangeRequestDto[]>> {
    return this.httpClient.get<ApiResponseObject<EmpNumberChangeRequestDto[]>>(`${environment.apiUrl}/AdhocRequest/GetPendingEmpChangeRequest`);
  }
  
  approveEmpChange(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/AdhocRequest/ApproveEmpChange`, approveContractRequest);
  }
  rejectEmpChange(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/AdhocRequest/RejectEmpChange`, approveContractRequest);
  }
  requestExpressApproval(expressApproval: any): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/AdhocRequest/RequestExpressApproval`, expressApproval);
  }

  RenewContract(renewdata: any): Observable<ApiResponseObject<adhocDto>> {
   
    return this.httpClient.post<ApiResponseObject<adhocDto>>(`${environment.apiUrl}/AdhocRequest/RenewContract`, renewdata);
  }

  getMyPendingRenewalToApprove(): Observable<ApiResponseObject<ContractRenewalRequestDto[]>> {
    return this.httpClient.get<ApiResponseObject<ContractRenewalRequestDto[]>>(`${environment.apiUrl}/AdhocRequest/GetMyPendingRenewalToApprove`);
  }
  approveRenewal(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/AdhocRequest/ApproveRenewal`, approveContractRequest);
  }

  rejectRenewal(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/AdhocRequest/RejectRenewal`, approveContractRequest);
  }

 

  getByDateRange(dateRangeRequest: DateRangeRequest): Observable<ApiResponseObject<adhocDto[]>> {
   
    return this.httpClient.post<ApiResponseObject<adhocDto[]>>(`${environment.apiUrl}/AdhocRequest/getByDateRange`, dateRangeRequest);
  }
  

  
  MyApprovedLabourRequests(): Observable<ApiResponseObject<adhocDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<adhocDto[]>>(`${environment.apiUrl}/AdhocRequest/MyApprovedLabourRequests`);
  }
  
  // Adhoc 
  getAdhocContracts(): Observable<ApiResponseObject<adhocDto[]>> {
     ; 
    var result = this.httpClient.get<ApiResponseObject<adhocDto[]>>(`${environment.apiUrl}/AdhocRequest`);
    return result;
  }
   GetByFunction(id: number): Observable<ApiResponseObject<adhocDto[]>> {
      return this.httpClient.get<ApiResponseObject<adhocDto[]>>(`${environment.apiUrl}/AdhocRequest/GetByFunction/${id}`);
    }
    GetByCreator(email: string): Observable<ApiResponseObject<adhocDto[]>> {
      return this.httpClient.get<ApiResponseObject<adhocDto[]>>(`${environment.apiUrl}/AdhocRequest/GetByCreator/${email}`);
    }
    GetByStatus(email: string): Observable<ApiResponseObject<adhocDto[]>> {
      return this.httpClient.get<ApiResponseObject<adhocDto[]>>(`${environment.apiUrl}/AdhocRequest/GetByStatus/${email}`);
    }
  
}
